<div>
  @if (expanded) {
  <div class="text-center p-1">
    @if (footerReference) {
    <div class="footer-reference-container text-xs" [innerHTML]="footerReference | safehtml"></div>
    }
    <small class="version-container text-xs text-gray">{{ version }}</small>
  </div>
  }
  <mat-divider></mat-divider>
  <div class="flex justify-center">
    @if (!expanded) {
    <button
      (click)="toggleExpand.emit()"
      [title]="'frame.expand' | transloco"
      id="all_sidebar_btn_expand-sidebar"
      mat-icon-button
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
    } @if (expanded) {
    <button (click)="toggleExpand.emit()" class="w-full" id="all_sidebar_btn_collapse-sidebar" mat-button>
      <mat-icon>chevron_left</mat-icon>
      <span>{{ 'frame.collapse' | transloco }}</span>
    </button>
    }
  </div>
</div>
